import { useDispatch, useSelector } from "react-redux"
import {
  useFetchWithBody,
  usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, CHALLAN_TYPE, decryptText, ENUM_ADVSEARCH_PARAM, ENUM_BILL_TYPE, ENUM_CURRENCY_SETTING_VAL, ENUM_ENTRY_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_PAGEACTION_TYPE, ENUM_STATUS, ENUM_TRADEOF_CODE, ENUM_TRADEOF_TYPE, funGetPageAction, GetLoginCredentialDb, getModMandatory, getModValue, linksUrl, SALE_PUR_ENTRY_TYPE, URIEncrypt } from "../../constants/enum"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components"
import {
  Button,
  Chip,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  Select,
  SelectItem,
  useDisclosure,
} from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faCircleXmark,
  faDownload,
  faEdit,
  faFileInvoice,
  faHexagonNodes,
  faPlus,
  faPrint,
  faReceipt,
  faStamp,
  faTrash,
} from "@fortawesome/free-solid-svg-icons"

import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
  ROW_ACTION_BTN_TYPE,
} from "../../components/NextUITable"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { calculateTotal, formatCurrency, calculateTotalWeight, } from "../../Utility/utility"
import { toast } from "react-toastify"
import ConfirmBox from "../../components/ConfirmBox"
import { resetDetailParams, setDetailParams, setMemoDetail, setMemoParams, setModSettingData, setNewEntryMode, setReportData } from "../../state/memoEntrySlice"
import { Drawer } from "@mui/material"
import ReportViewer from "../report/ReportViewer"
import { enum_Report_Type } from "../report/ReportUtility"
import { resetReportData } from "../../state/invoiceEntrySlice"
import ExcelJS from "exceljs"
import { saveAs } from "file-saver"
import {
  getBillType,
  getDateFn,
  getMemoParticular,
  getPktType,
  getTradeOf,
} from "../report/ReportUtility"



const MemoEntryMaster = () => {
  let disapatch = useDispatch()
  let navigate = useNavigate()
  const { compCode, isMultipleCompany, yearId, } = useSelector((state) => state.company)
  const { rptData, modSettingData } = useSelector((state) => state.memoEntry);
  const { user, token } = useSelector((state) => state.auth)
  const [itemToDelete, setItemToDelete] = useState("")
  const [itemToEdit, setItemToEdit] = useState("")
  const { btype, trdtype, ptype } = useParams()
  const [entryLabel, setEntryLabel] = useState()
  const [selBillType, setSelBillType] = useState()
  const [selTradeOf, setSelTradeOf] = useState()
  const [selModName, setSelModName] = useState()
  const [selPktType, setSelPktType] = useState()
  const [naviCode, setnaviCode] = useState()
  const [selFilterStatus, setSelFilterStatus] = useState(new Set(
    [String(ENUM_STATUS.Pending), String(ENUM_STATUS.PartialFinal), String(ENUM_STATUS.PartialReturn)]))
  const [data, setData] = useState([])
  const [selAdvanceFilter, setSelAdvanceFilter] = useState({})
  const [pageApiAdvFilter, setPageApiAdvFilter] = useState({})
  const [openDrawer, setOpenDrawer] = useState(false);
  const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)
  const [CurrencySetting, setCurrencySetting] = useState("")
  const [pageActionType, setPageActionType] = useState("")



  const {
    isOpen: isOpenReportModel,
    onOpen: onOpenReportModel,
    onOpenChange: onOpenReportModelChange,
  } = useDisclosure()
  //console.log(selFilterStatus, selFilterStatus.size)
  useEffect(() => {
    if (isMultipleCompany)
      navigate(linksUrl.dashboard)
    disapatch(resetDetailParams())
    disapatch(resetReportData())

  }, [])
  const isSinglePacket = () => {
    if (ptype != "") {
      if (ptype == URIEncrypt.SinglePacket)
        return true
      else
        return false
    }
    else
      return false
  }
  const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
    url: apiRoute.modSetting.getModSetting,
    queryKey: "fetchModSettingCurrency",
    inputData: {
      mod_name: ENUM_MOD_NAME.GeneralSettings
    }
  })
  const { data: tempData = [] } = useFetchWithBody({
    url: apiRoute.reportTemplate.fetchReportTemp,
    queryKey: "Memo Template Data List",
    inputData: {
      compcode: compCode.join(","),
      report_type: enum_Report_Type.SALEMEMO

    }

  });
  useEffect(() => {
    if (modSetting && modSetting.length > 0) {
      const mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, modSetting);
      setIsUseMfgNoAsMktno(mktSetting)
      const currSetting = getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, modSetting) ?? ENUM_CURRENCY_SETTING_VAL.RS;
      setCurrencySetting(currSetting)
    }
  }, [modSetting])

  useEffect(() => {

    const params = [URIEncrypt.Polish, URIEncrypt.Rough, URIEncrypt.Rejection]
    if (!params.includes(String(trdtype))
      || ![URIEncrypt.Sale, URIEncrypt.Purchase].includes(String(btype))
      || ![URIEncrypt.SinglePacket, URIEncrypt.Mix].includes(String(ptype))
    )
      navigate(linksUrl.dashboard.tradingDashboard)

    if (btype && btype != "" && trdtype && trdtype != "" || ptype && ptype != "") {

      let t_trdtype = trdtype
      let t_btype = btype
      let t_tradeof = ''
      let t_entryLabel = ''
      let t_billtype = ''
      let t_ptype = ''
      let modName = ""


      if (ptype == URIEncrypt.SinglePacket)
        t_ptype = 'SNG'
      else
        t_ptype = 'MIX'

      if (t_btype == URIEncrypt.Sale) {
        t_billtype = 'S'
      }
      else if (t_btype == URIEncrypt.Purchase) {
        t_billtype = 'P'
      }
      if (t_trdtype == URIEncrypt.Polish) {
        t_tradeof = ENUM_TRADEOF_CODE.Polish
        t_entryLabel = "Polish Diamond "
        if (t_billtype == 'S') { modName = isSinglePacket() ? ENUM_MOD_NAME.SalePolishMemoSingle : ENUM_MOD_NAME.SalePolishMemoMix }
        else if (t_billtype == 'P') { modName = isSinglePacket() ? ENUM_MOD_NAME.PurchasePolishMemoSingle : ENUM_MOD_NAME.PurchasePolishMemoMix }
        setnaviCode(t_billtype == 'S' ? linksUrl.saleEntry.polishDiamond : t_billtype == 'P' ? linksUrl.purchaseEntry.polishDiamond : "")
      }
      else if (t_trdtype == URIEncrypt.Rough) {
        t_tradeof = ENUM_TRADEOF_CODE.Rough
        t_entryLabel = "Rough Diamond "
        if (t_billtype == 'S') { modName = isSinglePacket() ? ENUM_MOD_NAME.SaleRoughMemoSingle : ENUM_MOD_NAME.SaleRoughMemoMix }
        else if (t_billtype == 'P') { modName = isSinglePacket() ? ENUM_MOD_NAME.PurchaseRoughMemoSingle : ENUM_MOD_NAME.PurchaseRoughMemoMix }
        setnaviCode(t_billtype == 'S' ? linksUrl.saleEntry.roughDiamond : t_billtype == 'P' ? linksUrl.purchaseEntry.roughDiamond : "")
      }
      else if (t_trdtype == URIEncrypt.Rejection) {
        t_tradeof = ENUM_TRADEOF_CODE.Rejection
        t_entryLabel = "Rejection Diamond "
        if (t_billtype == 'S') { modName = isSinglePacket() ? ENUM_MOD_NAME.SaleRejectionMemoSingle : ENUM_MOD_NAME.SaleRejectionMemoMix }
        else if (t_billtype == 'P') { modName = isSinglePacket() ? ENUM_MOD_NAME.PurchaseRejectionMemoSingle : ENUM_MOD_NAME.PurchaseRejectionMemoMix }
        setnaviCode(t_billtype == 'S' ? linksUrl.saleEntry.rejectDiamond : t_billtype == 'P' ? linksUrl.purchaseEntry.rejectDiamond : "")
      }

      setSelTradeOf(t_tradeof)
      setSelBillType(t_billtype)
      setEntryLabel(t_entryLabel)
      setSelPktType(t_ptype)
      setSelModName(modName)
      funFilterData(t_billtype, t_tradeof, t_ptype, null, null, null, null, null, null);
      setPageApiAdvFilter({ CompCode: compCode.join(','), BillType: t_billtype, TradeOf: t_tradeof })
    }


  }, [btype, trdtype, ptype])

  const FILTER_STATUS = [
    { value: "Final", key: [ENUM_STATUS.Final] },
    { value: "Pending", key: [ENUM_STATUS.Pending] },
    { value: "Partial Final", key: [ENUM_STATUS.PartialFinal] },
    { value: "Return", key: [ENUM_STATUS.Return] },
    { value: "Partial Retrun", key: [ENUM_STATUS.PartialReturn] }
  ]

  const {
    isError,
    isPending,
    data: memoData = [],
    mutate: filterData
  } = usePost({
    url: apiRoute.memoEntry.fetch,
    queryKey: "Memo Data List",

  })

  useEffect(() => {
    let newData = memoData
    if (memoData && memoData.length > 0) {
      if (selFilterStatus.size == 0)
        setData(memoData)
      else {
        const selStatus = selFilterStatus
        newData = memoData.filter(ele => selStatus.has(ele.status))
        setData(newData)
      }
    }
    else
      setData(memoData)
    //if (selFilterStatus.size == 0) {
    // setData(memoData)
    // setSelFilterStatus(new Set([String(ENUM_STATUS.Pending), String(ENUM_STATUS.PartialFinal)]))
    // }
  }, [memoData, selFilterStatus])
  const funFilterData = (billtype, tradeof, pkttype, scode, qcode, szcode, shcode, lwcode, itemcode, pacid, brid, fromdate, todate) => {
    filterData({
      data: {
        compcode: compCode.join(","),
        billtype: billtype,
        tradeof: tradeof,
        pkttype: pkttype == 'SNG' ? pkttype : '',
        s_code: scode,
        q_code: qcode,
        sh_code: shcode,
        sz_code: szcode,
        lw_code: lwcode,
        item_code: itemcode,
        pac_id: pacid,
        br_id: brid,
        from_date: fromdate,
        to_date: todate

      }
    })

  }

  const onSuccessDelete = (data) => {
    setItemToDelete("")

    if (data && data.length > 0) {
      if (data[0].ref == 1) {
        toast.error("Memo can't be delete as it locked", {
          position: "top-center",
          "className": "toast-error",
        })
      }
      else {
        toast.success("deleted successfully", {
          position: "top-center",

        })
        funFilterData(selBillType, selTradeOf, selPktType, null, null, null, null, null, null, null, null, null, null);
      }

    }

  }

  const { mutate: FndeleteNote } = usePost(
    {
      url: apiRoute.memoEntry.deleteEntry,
      query: "delete-note",
      onSuccessTasks: onSuccessDelete
    }
  )

  let totalAmt = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "NetAmt",
      }),
    [data]
  )
  let totalAmtD = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "NetAmtD",
      }),
    [data]
  )
  let totalBalWeight = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "BalWeight",
      }),
    [data]
  )
  console.log(data, "d")
  const INITIAL_VISIBLE_COLUMNS = [
    "actions",
    "Party_Name",
    "Memo_Det",
    "Chal_No",
    "NetAmt",
    "NetAmtD",
    "BalWeight",
    "AvgRateD",
    "AvgRate",
    "Chal_Date",
    //"Account_Name",
    "status"

  ]

  const [initialColumn, setInitialColumn] = useState(INITIAL_VISIBLE_COLUMNS)

  const exportColumns = [
    {
      name: "PARTY NAME",
      uid: "Party_Name",
    },
    {
      name: "Description",
      uid: "Memo_Det",
    },
    {
      name: "MEMO NO",
      uid: "Chal_No",
    },
    {
      name: "AMOUNT",
      uid: "NetAmt",
      type: COLUMN_TYPE.number
    },
    {
      name: "AMOUNT($)",
      uid: "NetAmtD",
      type: COLUMN_TYPE.number

    },
    {
      name: "Bal Weight",
      uid: "BalWeight",
      type: COLUMN_TYPE.number
    },
    {
      name: "Avg Rate($)",
      uid: "AvgRateD",
      type: COLUMN_TYPE.number
    },
    {
      name: "Avg Rate",
      uid: "AvgRate",
      type: COLUMN_TYPE.number
    },
    {
      name: "DATE",
      uid: "Chal_Date",
      type: COLUMN_TYPE.date
    },
    // {
    //   name: "ACCOUNT",
    //   uid: "Account_Name",
    // },
    {
      name: "Status",
      uid: "status",
    },
  ]
  const [exportCols, setExportCols] = useState(exportColumns)

  let downloadDataFooter = {
    Party_Name: "",
    Memo_Det: "",
    Memo_No: "",
    NetAmt: "Total: " + totalAmt,
    NetAmtD: "Total: " + totalAmtD,
    BalWeight: "Total:" + totalBalWeight,
    AvgRateD: "",
    AvgRate: "",
    Date: "",
    //Account: "",
  }

  const [exportFooter, setExportFooter] = useState(downloadDataFooter)

  useEffect(() => {
    if (CurrencySetting && CurrencySetting != "") {
      let AmtColumn = []
      if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS)
        AmtColumn = ["NetAmtD", "AvgRateD"]
      else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar)
        AmtColumn = ["NetAmt", "AvgRate"]
      else {
        setInitialColumn(INITIAL_VISIBLE_COLUMNS)
        setExportCols(exportColumns)
        setExportFooter(downloadDataFooter)
      }

      if (AmtColumn.length > 0) {
        const filterIniCol = initialColumn.filter(ele => ele != AmtColumn)
        const filterExpCol = exportColumns.filter((ele) => ele.uid != AmtColumn)
        //let footerCol = AmtColumn == 'NetAmtD' ? 'Amount$' : 'Amount'
        const filterExpFooter = Object.keys(downloadDataFooter).filter((ele) => !AmtColumn.includes(ele))
        setExportCols(filterExpCol)
        setInitialColumn(filterIniCol)
        setExportFooter(filterExpFooter)
      }
    }
  }, [CurrencySetting])

  // exportSaleMemoExcel.js



  const exportSaleMemoExcel = async () => {
    console.log(rptData, modSettingData)
    const moddata = modSettingData
    const termsdata = tempData && tempData.length > 0 ? tempData[0]?.Terms || "" : ""
    const rptdata = rptData
    const currencysetting = CurrencySetting
    console.log(tempData, "tem")

    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet("Sale Memo", {
      pageSetup: {
        paperSize: 9,
        orientation: "landscape",
        fitToPage: true,
      },
    })

    // ---------------------------
    // COLUMN WIDTHS
    // ---------------------------

    worksheet.columns = [
      { width: 8 },   // A
      { width: 35 },  // B
      { width: 10 },  // C
      { width: 12 },  // D
      { width: 12 },  // E
      { width: 14 },  // F
    ]

    const border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    }

    const center = {
      vertical: "middle",
      horizontal: "center",
      wrapText: true,
    }

    const left = {
      vertical: "middle",
      horizontal: "left",
      wrapText: true,
    }

    const item = rptdata?.[0]

    let row = 1

    // =========================
    // HEADER
    // =========================

    worksheet.mergeCells(`A${row}:L${row}`)
    worksheet.getCell(`A${row}`).value = item?.CompName || ""

    worksheet.getCell(`A${row}`).font = {
      bold: true,
      size: 16,
    }

    worksheet.getCell(`A${row}`).alignment = center

    row++

    worksheet.mergeCells(`A${row}:L${row}`)

    worksheet.getCell(`A${row}`).value =
      `${item?.Comp_Add1 || ""} ${item?.Comp_Add2 || ""} ${item?.Comp_City || ""}`

    worksheet.getCell(`A${row}`).alignment = center

    row++

    worksheet.mergeCells(`A${row}:L${row}`)

    worksheet.getCell(`A${row}`).value =
      `GSTIN: ${item?.Comp_GSTNo || ""}`

    worksheet.getCell(`A${row}`).alignment = center

    row += 2

    // =========================
    // TITLE
    // =========================

    worksheet.mergeCells(`A${row}:L${row}`)

    worksheet.getCell(`A${row}`).value =
      `${getBillType(item?.Bill_Type)} ${getTradeOf(item?.Trade_Of)} Memo (${getPktType(item?.PktType)})`

    worksheet.getCell(`A${row}`).font = {
      bold: true,
      size: 12,
    }

    worksheet.getCell(`A${row}`).alignment = center
    worksheet.getCell(`A${row}`).fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "D9D9D9" },
    }

    row += 2

    // =========================
    // PARTY INFO
    // =========================

    worksheet.getCell(`A${row}`).value = "Memo No"
    worksheet.getCell(`A${row}`).font = { bold: true }
    worksheet.getCell(`B${row}`).value = item?.Vou_No

    worksheet.getCell(`D${row}`).value = "Date"
    worksheet.getCell(`D${row}`).font = { bold: true }
    worksheet.getCell(`E${row}`).value = getDateFn(item?.Chal_Date)

    row++

    worksheet.getCell(`A${row}`).value = "Party Name"
    worksheet.getCell(`A${row}`).font = { bold: true }
    worksheet.getCell(`B${row}`).value = item?.PartyName

    worksheet.getCell(`D${row}`).value = "Broker"
    worksheet.getCell(`D${row}`).font = { bold: true }
    worksheet.getCell(`E${row}`).value = item?.BrokerName

    row += 2

    // =========================
    // TABLE HEADER
    // =========================

    const headers = [
      "Sr No",
      "Particular",

      //"Shape",
      //"StoneId",
      "Color",
      "Purity",
      "Pcs",
      "Weight",
    ]

    if (currencysetting !== ENUM_CURRENCY_SETTING_VAL.Dollar) {
      headers.push("Rate")
      headers.push("Amount")
    }
    headers.push("ReportNo")
    headers.push("Cut")
    headers.push("Polish")
    headers.push("Symtry")
    headers.forEach((h, i) => {
      const cell = worksheet.getCell(row, i + 1)

      cell.value = h
      cell.font = { bold: true }
      cell.alignment = center
      cell.border = border

      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "E5E5E5" },
      }
    })

    row++

    // =========================
    // TABLE DATA
    // =========================

    let visibleCol = []

    if (moddata?.pageData) {
      visibleCol = moddata.pageData
        .filter((e) => e.Visible === "true")
        .map((e) => e.Parameter)
    }

    rptdata.forEach((d, index) => {

      const values = [
        index + 1,
        // `${getMemoParticular(visibleCol, d)} ${d.Item_Det || ""}`,``
        `${d?.L_Code}-${d?.PktNo} - ${d?.ShapeName} `,
        // `${d?.L_Code}-${d?.PktNo}`,
        d?.ColorName,
        d?.PurityName,

        d.Nos,
        d.Weight,
      ]

      if (currencysetting !== ENUM_CURRENCY_SETTING_VAL.Dollar) {
        values.push(d.Rate)
        values.push(d.Amount)
      }
      values.push(d?.ReportNo)
      values.push(d?.Cut)
      values.push(d?.Polish)
      values.push(d?.Symtry)
      values.forEach((v, i) => {

        const cell = worksheet.getCell(row, i + 1)

        cell.value = v
        cell.border = border
        cell.alignment = i === 1 ? left : center

      })

      row++
    })

    // =========================
    // TOTAL
    // =========================

    const totalPcs = calculateTotal({
      data: rptdata,
      columnName: "Nos",
    })

    const totalWeight = calculateTotalWeight({
      data: rptdata,
      columnName: "Weight",
    })

    const totalAmount = calculateTotal({
      data: rptdata,
      columnName: "Amount",
    })

    worksheet.getCell(`A${row}`).value = ""
    worksheet.getCell(`B${row}`).value = "TOTAL"
    worksheet.getCell(`C${row}`).value = ""
    worksheet.getCell(`D${row}`).value = ""
    worksheet.getCell(`E${row}`).value = totalPcs
    worksheet.getCell(`F${row}`).value = totalWeight
    // worksheet.getCell(`G${row}`).value = 

    if (currencysetting !== ENUM_CURRENCY_SETTING_VAL.Dollar) {
      worksheet.getCell(`H${row}`).value = totalAmount
    }

    for (let i = 1; i <= 12; i++) {
      const cell = worksheet.getCell(row, i)

      cell.font = { bold: true }
      cell.border = border
      cell.alignment = center
    }

    row += 3

    // =========================
    // SIGNATURE
    // =========================

    worksheet.mergeCells(`A${row}:D${row}`)
    worksheet.mergeCells(`E${row}:H${row}`)
    worksheet.getCell(`A${row}`).value = ""
    worksheet.getCell(`D${row}`).value = `For : ${item?.CompName}`
    worksheet.getCell(`D${row}`).font = { bold: true }
    worksheet.getCell(`D${row}`).alignment = {
      vertical: "top",
      horizontal: "center",
      wrapText: true,
    }
    worksheet.getRow(row).height = 30

    row += 1
    worksheet.mergeCells(`A${row}:D${row}`)
    worksheet.mergeCells(`E${row}:H${row}`)
    worksheet.getCell(`A${row}`).value = "Received Signatory"
    worksheet.getCell(`A${row}`).font = { bold: true }
    worksheet.getCell(`E${row}`).value = "Authoriesd Signature"
    worksheet.getCell(`E${row}`).font = { bold: true }
    worksheet.getCell(`A${row}`).alignment = center
    worksheet.getCell(`E${row}`).alignment = center


    const terms = termsdata || ""

    const termsList = terms
      .split("<br/>")
      .filter((t) => t.trim() !== "")

    row += 2

    worksheet.mergeCells(`A${row}:L${row}`)

    worksheet.getCell(`A${row}`).value = "Terms & Conditions"

    worksheet.getCell(`A${row}`).font = {
      bold: true,
      size: 10,
    }

    worksheet.getCell(`A${row}`).alignment = {
      vertical: "top",
      horizontal: "left",
    }

    row++

    // Create numbered content
    const numberedTerms = termsList
      .map((term, index) => `${index + 1}. ${term.trim()}`)
      .join("\n\n")

    worksheet.mergeCells(`A${row}:L${row}`)

    worksheet.getCell(`A${row}`).value = numberedTerms

    worksheet.getCell(`A${row}`).alignment = {
      wrapText: true,
      vertical: "top",
      horizontal: "left",
    }

    worksheet.getCell(`A${row}`).font = {
      size: 8,
    }

    worksheet.getCell(`A${row}`).border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    }

    // Auto height based on lines
    worksheet.getRow(row).height = 250
    // worksheet.getCell(`A${row}`).value =
    //   termsdata

    // worksheet.getCell(`A${row}`).alignment = {
    //   wrapText: true,
    //   vertical: "top",
    // }

    // worksheet.getRow(row).height = 80

    // =========================
    // GLOBAL STYLE
    // =========================

    worksheet.eachRow((r) => {
      r.eachCell((cell) => {
        cell.font = {
          name: "Arial",
          size: 9,
          ...(cell.font || {}),
        }
      })
    })

    // =========================
    // DOWNLOAD
    // =========================

    const buffer = await workbook.xlsx.writeBuffer()

    saveAs(
      new Blob([buffer]),
      `SaleMemo.xlsx`
    )

  }

  if (isError) {
    return <ErrorCard />
  }

  if (isPending) {
    return <LoadingCard />
  }

  const columns = [
    {
      name: "Actions",
      uid: "actions",
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "PARTY NAME",
      uid: "Party_Name",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "Description",
      uid: "Memo_Det",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.left,
      type: COLUMN_TYPE.multiline
    },
    {
      name: "MEMO NO",
      uid: "Chal_No",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "AMOUNT",
      uid: "NetAmt",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      type: COLUMN_TYPE.currency,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: formatCurrency(totalAmt),
      },
    },
    {
      name: "AMOUNT($)",
      uid: "NetAmtD",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      type: COLUMN_TYPE.number,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalAmtD,
      },
    },
    {
      name: "Bal Weight",
      uid: "BalWeight",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      type: COLUMN_TYPE.number,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalBalWeight,
      },
    },

    {
      name: "Avg Rate($)",
      uid: "AvgRateD",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      type: COLUMN_TYPE.number,

    },
    {
      name: "Avg Rate",
      uid: "AvgRate",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      type: COLUMN_TYPE.currency,
    },
    {
      name: "DATE",
      uid: "Chal_Date",
      type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    // {
    //   name: "ACCOUNT",
    //   uid: "Account_Name",
    //   align: COLUMN_ALIGN_TYPE.center,
    //   sortable: true,
    // },
    {
      name: "Status",
      uid: "status",
      align: COLUMN_ALIGN_TYPE.center,

    },
  ]
  const reportModel = () => {
    return (
      <div>
        <Modal
          isOpen={isOpenReportModel}
          onOpenChange={onOpenReportModelChange}
          size="3xl"
          scrollBehavior="inside"
          placement="center"
        >
          <ModalContent>
            {(onClose) => (
              <>

                <ModalHeader className="m-0 px-2  bg-gray-100 border-b-2 border-gray-700">
                  {`${selBillType == "S" ? "Sale" : "Purchase "} ${entryLabel}  Memo  (${selPktType == 'SNG' ? "Single" : "Mix"})`}

                </ModalHeader>
                <ModalBody className="p-0 m-0">
                  {/* <div className="flex justify-end">
                    <button className="px-5 uppercase text-sm font-semibold rounded-sm shadow  text-white bg-blue-700" onClick={exportSaleMemoExcel}>
                      <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon> Export Excel</button> 
                  </div>*/}
                  <ReportViewer props_ReportType={enum_Report_Type.MEMO} />
                </ModalBody>
              </>
            )}
          </ModalContent>
        </Modal>
      </div>
    )
  }
  const handleConfirmBox = (data) => {
    if (data) {
      if (itemToDelete != "" && itemToDelete != null && Object.keys(itemToDelete).length > 0) {

        FndeleteNote({
          data: {
            transaction_id: itemToDelete.transaction_id,
            comp_code: itemToDelete.comp_code,
            pkt_type: itemToDelete.pkt_type,
            bill_type: itemToDelete.bill_type,
            trade_of: selTradeOf,
            mkt_lotno: isUseMfgNoAsMktno ? '0' : "1"

          }
        })
      }
      else if (itemToEdit != "" && itemToEdit != null && Object.keys(itemToEdit).length > 0) {
        disapatch(setDetailParams(itemToEdit))
        disapatch(setNewEntryMode(false))
        if (selPktType == 'MIX')
          navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.mixEntry + linksUrl.memoEntry.createMemoEntry)
        else
          navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.memoEntry.createMemoEntry)
      }

    }
    else {
      setItemToDelete("")
      setItemToEdit("")
      setPageActionType("")
    }

  }

  const rowActionBtn = [

    {
      icon: <FontAwesomeIcon color="#FFFFFF" icon={faHexagonNodes} />,
      //1656e7
      onClick: (row) => {
        let obj = {
          comp_code: row.CompCode,
          transaction_id: row.TransactionId,
          bill_type: row.Bill_Type,
          trade_of: row.Trade_Of,
          status: row.status

        }

        disapatch(setMemoParams(obj))
        // window.open(
        //   `${window.location.origin}${linksUrl.memoEntry.memoEntryMaster}/${btype}/${trdtype}/${ptype}${linksUrl.memoFinalizeEntry}`,
        //   "_blank"
        // );
        navigate(linksUrl.memoEntry.memoEntryMaster + "/" + btype + "/" + trdtype + "/" + ptype + linksUrl.memoFinalizeEntry)

      },
      label: "Action",
      color: "bg-blue-700",
      type: ROW_ACTION_BTN_TYPE.button,
    },
    {
      icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
      onClick: (row) => {
        setItemToDelete("")
        setPageActionType(ENUM_PAGEACTION_TYPE.Edit)
        let obj = {
          comp_code: row.CompCode,
          transaction_id: row.TransactionId,
          bill_type: row.Bill_Type,
          trade_of: row.Trade_Of,
          status: row.status

        }
        setItemToEdit(obj)

        // disapatch(setDetailParams(obj))
        /// disapatch(setNewEntryMode(false))
        // if (selPktType == 'MIX')
        //   navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.mixEntry + linksUrl.memoEntry.createMemoEntry)
        // else
        //   navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.memoEntry.createMemoEntry)


      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
      onClick: (row) => {
        if (row.status == "Pending") {
          setItemToEdit("")
          setPageActionType(ENUM_PAGEACTION_TYPE.Delete)
          setItemToDelete({ transaction_id: row.TransactionId, comp_code: row.CompCode, pkt_type: row.PktType, bill_type: row.Bill_Type })
        }
        else {
          toast.error("Memo can't be delete as it locked", {
            "position": "top-center",
            "className": "toast-error",
          })
        }
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon color="#c511b7" icon={faPrint} />,
      onClick: (row) => {
        let obj = {
          comp_code: row.CompCode,
          bill_type: row.Bill_Type,
          trade_of: row.Trade_Of,
          trans_id: row.TransactionId,
          token: token,
          db_user: GetLoginCredentialDb(user, yearId)

        }
        let objMod = {
          mod_name: selModName,
          token: token,
          db_user: GetLoginCredentialDb(user, yearId)
        }
        disapatch(resetReportData())
        disapatch(setMemoDetail(obj))
        disapatch(setModSettingData(objMod))

        onOpenReportModel()
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },

  ]

  const handleAddNew = () => {
    disapatch(resetDetailParams())
    if (selPktType == 'MIX')
      navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.mixEntry + linksUrl.memoEntry.createMemoEntry)
    else
      navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.memoEntry.createMemoEntry)

  }
  const ADVFILTER_VISIBLE_FIELD = [
    // ...Object.values(ENUM_ADVSEARCH_PARAM)
    ENUM_ADVSEARCH_PARAM.Shape,
    ENUM_ADVSEARCH_PARAM.Purity,
    ENUM_ADVSEARCH_PARAM.Color,
    ENUM_ADVSEARCH_PARAM.Size,
    ENUM_ADVSEARCH_PARAM.Party,
    ENUM_ADVSEARCH_PARAM.Broker,
    ENUM_ADVSEARCH_PARAM.Item,
    ENUM_ADVSEARCH_PARAM.LwRatio,
    ENUM_ADVSEARCH_PARAM.VouFromDate,
    ENUM_ADVSEARCH_PARAM.VouToDate,
    //ENUM_ADVSEARCH_PARAM.VouNo,
  ]
  const handleFilterChange = (newFilters) => {
    //console.log('Received filters in parent:', newFilters);
    setSelAdvanceFilter(newFilters)
    funFilterData(selBillType, selTradeOf, selPktType,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Shape) ? newFilters[ENUM_ADVSEARCH_PARAM.Shape] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Purity) ? newFilters[ENUM_ADVSEARCH_PARAM.Purity] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Size) ? newFilters[ENUM_ADVSEARCH_PARAM.Size] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Color) ? newFilters[ENUM_ADVSEARCH_PARAM.Color] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.LwRatio) ? newFilters[ENUM_ADVSEARCH_PARAM.LwRatio] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Item) ? newFilters[ENUM_ADVSEARCH_PARAM.Item] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Party) ? newFilters[ENUM_ADVSEARCH_PARAM.Party] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Broker) ? newFilters[ENUM_ADVSEARCH_PARAM.Broker] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.VouFromDate) ? newFilters[ENUM_ADVSEARCH_PARAM.VouFromDate] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.VouToDate) ? newFilters[ENUM_ADVSEARCH_PARAM.VouToDate] : null,

    )

  };

  const handleChange = (e) => {
    setSelFilterStatus(new Set(e.target.value.split(",")));
  }
  const handleDelet = (key) => {
    const newFilter = selFilterStatus
    newFilter.delete(key)
    setSelFilterStatus(new Set(newFilter));
  }



  return (
    <div>

      {(itemToDelete || itemToEdit) && (
        <ConfirmBox
          handleConfirmBox={handleConfirmBox}
          actionType={pageActionType}
        />
      )}


      <MainContainer
        pageName={entryLabel + `Memo - ${selPktType == 'SNG' ? "Single Packet" : selPktType}`}
        info={[]}
        breadcrumbs={[selBillType == 'S' ? 'Sale' : 'Purchase', entryLabel, "Memo", selPktType == 'SNG' ? "Single Packet" : selPktType]}
      >

        <div className="flex justify-between" >
          <div className="w-full">
            <Select
              className="w-full "
              isMultiline={true}
              color="default"
              classNames={{
                base: "max-w-md",
                label: "font-semibold"
                //trigger: "min-h-5 py-2",
              }}
              items={FILTER_STATUS}
              label="Memo Status"
              labelPlacement="outside"
              size="sm"
              renderValue={(items) => {
                return (
                  <div className="flex flex-wrap gap-2" >
                    {items.map((item) => (
                      <div key={item.key} className="flex">
                        <Chip size="sm" radius="sm" variant="flat" color="default" key={item.key}><strong> {item.data.value}</strong></Chip>
                        <FontAwesomeIcon className="text-xs text-orange-700" onClick={() => handleDelet(item.key)} icon={faCircleXmark} /></div>
                    ))}
                  </div>
                );
              }}

              selectedKeys={selFilterStatus}
              selectionMode="multiple"
              onChange={handleChange}
              variant="bordered"
            >
              {(list) => (
                <SelectItem
                  key={list.key}
                >
                  {list.value}
                </SelectItem>
              )}
            </Select>
          </div>
          <Button
            size="sm"
            color="primary"
            startContent={<FontAwesomeIcon icon={faPlus} />}
            onPress={handleAddNew}
          >
            Add New
          </Button>
        </div>
        {reportModel()}
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={initialColumn}
          data={data}
          columns={columns}
          rowActionBtn={rowActionBtn}
          exportColumns={exportCols}
          downloadDataFooter={exportFooter}
          downloadFileName={entryLabel + "Memo-List"}
          onFilterChange={handleFilterChange}
          showAdvancedFilter={true}
          id="TransactionId"
          advanceFilterParam={selAdvanceFilter}
          advFilterPageApiParam={pageApiAdvFilter}
          advFilterVisibleField={ADVFILTER_VISIBLE_FIELD}
        ></NextUITable>
      </MainContainer>
    </div>
  )
}
export default MemoEntryMaster
